module.exports = __webpack_public_path__ + "static/media/flag-cn.3186a39d.webp";